import { gql } from '@apollo/client'
export const GLOBAL_SEARCH = gql`
  query GlobalSearch($searchTerm: String!) {
    globalSearch(searchTerm: $searchTerm) {
      ... on person {
        id
        account_id
        type
        conversation {
          id
        }
        first_name
        middle_name
        last_name
        phones {
          id
          phone_number
        }
        emails {
          id
          address
        }
        person_properties {
          id
          property {
            id
            name
            street_address
            city
            state
            zip
          }
        }
        sticky_number {
          id
          phone_number
          property {
            id
            name
            street_address
            city
            state
            zip
          }
        }
        unit_occupancy_tenants {
          id
          unit_occupancy {
            id
            property {
              id
              name
              street_address
              city
              state
              zip
            }
          }
        }
      }
    }
  }
`
